import { clientGetActivityAllConfig } from "@/api/clientApi/activity";
import {
  getConfigVersion,
  getFrontCfg,
  getSysConfig,
} from "@/api/clientApi/front";
import { sdkManager } from "@/lib/sdk/sdkManager";
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from "@/lib/sessionStorage";
import {
  ActivityCfgMap,
  addVipData,
  setActivityCfgMap,
  setBonusCategoryList,
} from "@/stores/activityStore";
import {
  configStore,
  setAndroidAppDownloadLinks,
  setConfigVersion,
  setFrontCfgMap,
} from "@/stores/configStore";
import { getSdkData, initSysConfigStore } from "@/stores/sysConfigStore";
import { setUserStore } from "@/stores/userStore";
import { FrontCfgV2Map } from "@/types/config";
import { ActivityCfg } from "@/types/swagger/activity";
import { GetConfigVersionRsp, GetSysConfigRsp } from "@/types/swagger/front";

export function useConfigUpdate() {
  const updateConfigVersion = (firstLoad = false) => {
    getConfigVersion().then((res: GetConfigVersionRsp | undefined) => {
      if (res) {
        setConfigVersion(res);
        setAndroidAppDownloadLinks(res.app_links);
        if (firstLoad) {
          sdkManager.initBeforeLoad();
          const sessionStorageOkSpin = getSessionStorageItem("okspin", 0);
          if (sessionStorageOkSpin == 0) {
            setSessionStorageItem("okspin", 1);
            sdkManager.okSpinReportEvent("browseropen", {});
          }
          sdkManager.okSpinReportEvent("contentview", {});
          getSdkData(); //获取sdk数据
        }
        setUserStore("pack_no", res.pack_no || 0);
        setUserStore("general", res.general || 0);
        if (Number(res.version) > Number(configStore?.version)) {
          updateFrontCfg();
          updateSysConfig();
          clientGetActivityAllConfig()
            .then((res) => {
              const activityCfg = res.activityCfg;
              if (activityCfg?.activity_cfg_list) {
                Object.values(activityCfg.activity_cfg_list).forEach((el) => {
                  addVipData(el.cfg);
                });
              }
              const cfg = activityCfg?.activity_cfg_list;
              const allActCfg = {} as ActivityCfgMap;
              const list = [] as number[];

              if (cfg) {
                Object.values(cfg).forEach((value: ActivityCfg) => {
                  if (!allActCfg[value.atype]) {
                    allActCfg[value.atype] = value;
                    if (value.bonus_category) {
                      list.push(value.bonus_category);
                    }
                  }
                });
              }

              setActivityCfgMap(allActCfg);
              setBonusCategoryList(list);
            })
            .catch((err) => {
              console.log("err----------", err);
            });
        }
      }
    });
  };

  const updateSysConfig = async () => {
    const res = await getSysConfig();
    if (res) {
      initSysConfigStore(res as GetSysConfigRsp);
    }
  };

  const updateFrontCfg = async () => {
    const res = await getFrontCfg();
    if (res && res.list && Array.isArray(res.list)) {
      const cfg = res.list;
      const frontCfgMap = cfg.reduce((acc, item) => {
        acc[item.key] = { ...item.data } as FrontCfgV2Map[keyof FrontCfgV2Map];
        return acc;
      }, {} as FrontCfgV2Map);
      setFrontCfgMap(frontCfgMap);
    }
  };

  return {
    updateConfigVersion,
    updateFrontCfg,
  };
}
